module.exports = __webpack_public_path__ + "static/assets/60755d9ee7988e1861be59eb25d1ca0d.svg";